import { Controller } from '@hotwired/stimulus';
import lottie from 'lottie-web';

export default class extends Controller {
  static targets = ['animation'];
  animationLoop = true;
  animationPath;

  connect() {
    this.animationPath = this.animationTarget.dataset.lottiePath;
    const playOnLoad = this.animationTarget.dataset.lottiePlayOnLoad === 'true';
    const playOnLoadOnce = this.animationTarget.dataset.lottiePlayOnLoadOnce === 'true';
    if (this.animationPath && playOnLoad) { this.loadAnimation(); }
    else if (this.animationPath && playOnLoadOnce) { this.playAndDisplayOnce(); }
  }

  loadAnimation() {
    this.currentAnimation = lottie.loadAnimation({
      container: this.animationTarget,
      renderer: 'svg',
      loop: this.animationLoop,
      autoplay: true,
      path: this.animationPath
    });
  }

  playAndDisplayOnce() {
    this.animationTarget.classList.remove('hidden');
    this.animationLoop = false;
    if (!this.currentAnimation) {
      this.loadAnimation();
    }

    this.currentAnimation.goToAndPlay(0, true);

    setTimeout(() => {
      this.animationTarget.classList.add('hidden');
    }, 1000);
  }

  disconnect() {
    this.#destroyAnimation();
  }

  #destroyAnimation() {
    if (this.currentAnimation) {
      this.currentAnimation.destroy();
    }
  }
}
